import { CommissionStatuses } from 'constants/commissionStatuses';

import { useState } from 'react';

import { useRecordContext } from 'react-admin';
import { Divider } from 'shared/mui/Divider/Divider';
import { Typography } from 'shared/mui/Typography';
import { TaskStatusField } from 'shared/react-admin/Fields/TaskStatusField/TaskStatusField';
import { CommissionsTabsTaskShowDialog } from 'shared/widgets/CommissionsTabs/CommissionsTabsTask/components/CommissionsTabsTaskShowDialog/CommissionsTabsTaskShowDialog';
import { CommissionRecalculationTask } from 'types/embedded/commissionRecalculationTask';
import { getTimezoneByName } from 'utils/getTimezoneByName';

import { WrapperStyled, TopRowStyled } from './CommissionsTabsTaskStatus.styled';
import { CommissionsTabsTaskStatusDeleteDialog } from './CommissionsTabsTaskStatusDeleteDialog/CommissionsTabsTaskStatusDeleteDialog';
import { CommissionsTabsTaskStatusEditDialog } from './CommissionsTabsTaskStatusEditDialog/CommissionsTabsTaskStatusEditDialog';
import { CommissionsTabsTaskStatusMenu } from './CommissionsTabsTaskStatusMenu/CommissionsTabsTaskStatusMenu';

type Props = {
  commissionStatus: CommissionStatuses;
};

export const CommissionsTabsTaskStatus: React.FC<Props> = ({ commissionStatus }) => {
  const [openView, setOpenView] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);

  const record = useRecordContext<CommissionRecalculationTask>();

  const handleView = () => {
    setOpenView(true);
  };

  const handleEdit = () => {
    setOpenEdit(true);
  };

  const handleDelete = () => {
    setOpenDelete(true);
  };

  const createdAtFormatted = record?.createdAt
    ? new Date(record.createdAt).toLocaleDateString('ru-RU')
    : '—';

  const timezone = getTimezoneByName(record?.timeZone);

  return (
    <WrapperStyled>
      <TopRowStyled>
        <div>
          <Typography variant="body2">Запуск перерасчёта от: {createdAtFormatted}</Typography>
          <Typography color="textSecondary" variant="body2">
            {timezone?.name} ({timezone?.offset})
          </Typography>
        </div>
        <div>
          <CommissionsTabsTaskStatusMenu
            commissionStatus={commissionStatus}
            onDelete={handleDelete}
            onEdit={handleEdit}
            onView={handleView}
          />
        </div>
      </TopRowStyled>
      <Divider sx={{ margin: '8px 0' }} />
      <TaskStatusField />
      <CommissionsTabsTaskShowDialog
        onClose={() => setOpenView(false)}
        open={openView}
        record={record}
      />
      <CommissionsTabsTaskStatusDeleteDialog
        onClose={() => setOpenDelete(false)}
        open={openDelete}
      />
      <CommissionsTabsTaskStatusEditDialog onClose={() => setOpenEdit(false)} open={openEdit} />
    </WrapperStyled>
  );
};
